<template>
<v-app :class="`${isTabletMode ? `tablet-mode` : ``}`">
    <nav-drawer v-if="$vuetify.breakpoint.mdAndDown && !isPopup" :menuItems="menuItems" @url-clicked="navigate($event.route, $event.newTab)"></nav-drawer>
    <div v-if="!isPopup && !isTabletMode" app class="hms-banner" :style="{ backgroundImage: 'url(' + require('@/assets/Costa_HMS_banner.png') + ')' }"></div>    
    <v-toolbar v-if="!isPopup && !isTabletMode" app fixed clipped-left color="white" dense class="hms-menu" min-height="100">
        <v-toolbar-side-icon @click.native="toggleDisplayNav" v-if="$vuetify.breakpoint.mdAndDown"></v-toolbar-side-icon>       
        <v-img contain :src="require('@/assets/Costa_Logo.png')" alt="Harvest Management System" max-width="80" min-width="50" @click="navigate('/')" class="clickable" ></v-img>
        <Menu id="menu" :menuItems="menuItems" :horizontal="true" v-if="!$vuetify.breakpoint.mdAndDown" @url-clicked="navigate($event.route, $event.newTab)" ></Menu>
        <v-spacer></v-spacer>
        <alert-notifications></alert-notifications>
        <profile></profile>
        <v-progress-linear slot="extension" :indeterminate="true" v-if="loadingRoute"></v-progress-linear>
    </v-toolbar>
    <v-content class="grey lighten-2 hms-content">
        <router-view></router-view>
    </v-content>
    <v-footer v-if="!isPopup && !isTabletMode" class="pa-3" >
        <v-img contain :src="require('@/assets/Costa_Logo.png')" max-width="70" alt="Costa Group" ></v-img>
        <v-spacer></v-spacer>
        <div>&copy; {{ new Date().getFullYear() }} Costa Group Pty Ltd</div>
    </v-footer>
</v-app>
</template>

<script>
import Profile from "./components/authentication/Profile.vue";
import Menu from "./components/navigation/Menu.vue";
import NavDrawer from "./components/navigation/NavDrawer.vue";
import AlertNotifications from "./components/alerts/AlertNotifications.vue";

export default {
    components: {
        NavDrawer,
        Profile,
        Menu,
        AlertNotifications
    },
    data() {
        return {
        };
    },
    computed: {
        isPopup(){
            return this.$route.meta.isPopup;
        },
        loadingRoute: function () {
            return this.$store.state.GeneralStore.loadingRoute;
        },
        menuItems : function () {
            return this.$store.getters["UserStore/getMenu"];
        },
        isTabletMode(){
            return this.$route.meta.isTabletMode && this.$vuetify.breakpoint.mdAndDown;
        }
    },
    methods: {
        toggleDisplayNav() {
            this.$store.commit("GeneralStore/toggleDisplayNavDrawer");
        },
        navigate(url, newTab = false) {
            if(url.startsWith("/")) {
                if(newTab){
                    window.open(url, "_blank");
                } else {
                    this.$router.push({
                        path: url
                    });
                }
            }
            else {
                if(newTab){
                    window.open("/" + process.env.VUE_APP_OLD_HMS_ROOT + "/" + url, "_blank");
                } else {
                    this.$store.commit("GeneralStore/setLoadingRoute", true);
                    window.location.href = "/" + process.env.VUE_APP_OLD_HMS_ROOT + "/" + url
                }
            }
        }
    },
    created(){
        if(process.env.VUE_APP_BUILD_SIGNATURE){
            console.log("Build Signature: " + process.env.VUE_APP_BUILD_SIGNATURE);
        }
    }
};
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

#app.tablet-mode .application--wrap {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    min-height: 0px;
}

#app.tablet-mode .v-overlay {
    display: none;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}

#menu {
    padding-left: 20px;
}

.hms-banner {
    position: relative;
    background-repeat: repeat-x;
    height:50px;
    background-position-y: center; 
    width: 100%;
}

.hms-menu {
    position: relative;
}

.hms-content {
    position: relative;
}

@media (max-width: 959px) {
    .container {
        padding: 0px;
    }
}

main.v-content.hms-content {
    padding: 0 !important;
}

.clickable {
    cursor: pointer;
}

.tabsHeightFix .v-window__container {
    height: 100% !important;
}

.dialog-action-buttons .flex:first-child {
    /* in dialog popups, just prevent buttons that are side by side from touching each other, and pull them away from the edges of the popup */
    padding-left: 6px;
    padding-right: 3px;
}

.dialog-action-buttons .flex:last-child {
    /* in dialog popups, just prevent buttons that are side by side from touching each other, and pull them away from the edges of the popup */
    padding-left: 3px;
    padding-right: 6px;
}

.dialog-action-buttons .flex {
    /* in dialog popups, just prevent buttons that are side by side from touching each other, and pull them away from the edges of the popup */
    padding-left: 3px;
    padding-right: 3px;
}

#adalIdTokenFrame {
    display: none;
}

/*
This is the data table fixed-header feature for vuetify 2.0, as the project is running on vuetify 1.5, I just grab this part of the feature. 
When this project is upgradeed to vuetify 2.0 or later, this can be replaced with 'fixed-header' under table props
*/
#app .v-data-table--fixed-header thead th {
    border-bottom: 0!important;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 2;
}
/*
This is the data table fixed-header feature for vuetify 2.0, as the project is running on vuetify 1.5, I just grab this part of the feature. 
When this project is upgradeed to vuetify 2.0 or later, this can be replaced with 'fixed-header' under table props
*/
#app .v-data-table--fixed-header thead th {
    background: #fff;
    box-shadow: inset 0 -1px 0 rgba(0,0,0,.12);
}
</style>
